export const casal = '#2c6464'
export const lemonGinger = '#ddd458'
